import React, { useEffect, useState } from "react";

const defaultIntents = {
  welcome: "Welcome",
  positive: "Thumbs up",
  negative: "Thumbs down",
  help: "Help",
};
const IntentsContext = React.createContext({
  intents: defaultIntents,
  Icons: {}
});

export const IntentsProvider = ({ children, intents, Icons }) => {
  const [currentIntents, setCurrentIntents] = useState({
    ...defaultIntents,
    ...intents,
  });

  useEffect(() => {
    setCurrentIntents((existing = {}) => ({
      ...existing,
      ...intents
    }))
  }, [intents])

  return (
    <IntentsContext.Provider value={{ intents: currentIntents, Icons: Icons ?? {} }}>
      {children}
    </IntentsContext.Provider>
  );
};

export const IntentsConsumer = IntentsContext.Consumer;

export default IntentsContext;
